import { Base } from './base';
export class NotEmpty extends Base {
    constructor(fieldName, value, errorMsg) {
        super(fieldName, value);
        this.errorMsg = `"${this.getFieldname()}" is required`;
        if (errorMsg) {
            this.errorMsg = errorMsg;
        }
    }
    isValid() {
        const value = String(this.value).trim();
        if (value.length == 0 || value == 'null' || value == 'undefined') {
            this.errors.push(this.errorMsg);
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=notEmpty.js.map